import { render, staticRenderFns } from "./UnfriendlyCountries.vue?vue&type=template&id=43b8101b"
import script from "./UnfriendlyCountries.vue?vue&type=script&lang=js"
export * from "./UnfriendlyCountries.vue?vue&type=script&lang=js"
import style0 from "./UnfriendlyCountries.vue?vue&type=style&index=0&id=43b8101b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports